<template>
  <v-card flat height="100%">
    <v-card-title>
      <v-tabs v-model="tabIndex" grow>
        <v-tab>{{ dealer.name }} Stats</v-tab>
        <v-tab>All Dealer Stats</v-tab>
      </v-tabs>
    </v-card-title>
    <v-card-text>
      <v-tabs-items v-model="tabIndex">
        <!-- By Dealer -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-container fluid>
                <v-row >
                  <daily-email-activity
                    chartPrefix="dealer"
                    :dealer="dealer"
                  />
                </v-row>
                <v-row >
                  <campaign-activity-stats
                    chartPrefix='dashboard'
                    :dealer="dealer"
                  />
                </v-row>
                <v-row class="child-flex">
                  <scheduled-email-campaigns
                    :allDealers="false"
                    :showDealersColumn="false"
                  ></scheduled-email-campaigns>
                </v-row>
              </v-container>

            </v-card-text>
          </v-card>
        </v-tab-item>
        <!-- All Dealers -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-container fluid>
                <v-row >
                  <daily-email-activity
                    chartPrefix="allDealers"
                  />
                </v-row>
                <v-row >
                  <activity-by-dealer />
                </v-row>
                <v-row class="child-flex">
                  <scheduled-email-campaigns
                    :allDealers="true"
                    :showDealersColumn="true"
                  ></scheduled-email-campaigns>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-tab-item>

      </v-tabs-items>
    </v-card-text>
  </v-card>

</template>

<script>
import { mapState } from 'vuex'
import { DailyEmailActivity, ActivityByDealer, CampaignActivityStats } from '@/components/charts'
import ScheduledCampaigns from '@/components/campaigns/email/ScheduledCampaigns'

export default {
  components: {
    [DailyEmailActivity.name]: DailyEmailActivity,
    [ActivityByDealer.name]: ActivityByDealer,
    [CampaignActivityStats.name]: CampaignActivityStats,
    [ScheduledCampaigns.name]: ScheduledCampaigns
  },
  data: function () {
    return {
      tabIndex: 0
    }
  },
  computed: {
    ...mapState('DealerStore', { dealer: 'dealer' })
  },
  methods: {},
  mounted: function () {}
}
</script>

<style>
</style>
